import { formatGold } from '../format';
import type { ScreenMount } from '../types';
import { buildDamageRecap } from './damageRecap';
import { icon } from '../icons';
import { gateStatus } from '../gameApi';

export const mountInvasionWon: ScreenMount = (container, ctx) => {
  const { game } = ctx;
  const s = game.state;
  // A112 : sans le jeu complet, le niveau suivant n'est pas « débloqué » : l'écran d'achat suit.
  const gate = gateStatus(game);
  const blocked = gate !== null && !gate.entitled && s.level >= gate.freeLevels;
  const el = document.createElement('div');
  el.className = 'screen screen--end screen--won screen--end-recap';
  // v0.16.0 (refonte F1, lot 3) : bandeau d'or de la victoire.
  el.innerHTML = `
    <div class="end-center">
      <header class="f-banner f-banner--win">
        <h1 class="end-title">Invasion repoussée&nbsp;!</h1>
        <p class="end-lead" data-role="won-lead">${blocked ? `Le niveau ${s.level + 1} vous attend` : `Niveau ${s.level + 1} débloqué`}</p>
      </header>
      <dl class="end-stats">
        <div class="f-stat f-stat--gold end-stat"><dt>Or crédité</dt><dd class="num">${formatGold(s.combat.gold)}</dd></div>
        <div class="f-stat end-stat"><dt>Ennemis tués</dt><dd class="num">${s.combat.kills}</dd></div>
      </dl>
    </div>
    <button type="button" class="f-btn f-btn--primary f-btn--block end-action" data-action="continue"><span>Continuer</span>${icon('arrow')}</button>
  `;
  // Récapitulatif des dégâts (COMMENTS §2) : l'Invasion y a droit comme
  // l'Expédition, replié d'entrée pour ne pas masquer la victoire.
  el.insertBefore(buildDamageRecap(game, { open: false }), el.lastElementChild);
  container.appendChild(el);

  const btn = el.querySelector<HTMLButtonElement>('[data-action="continue"]');
  const onClick = (): void => game.acknowledgeInvasionWon();
  btn?.addEventListener('click', onClick);

  return () => btn?.removeEventListener('click', onClick);
};
